import { useContext } from 'react';
import ResultTile from '@/srp/SearchResults/ResultTile/ResultTile';
import FavoritesContext from '~/context/srp/FavoritesContext';
import type { Vehicle } from '~/contracts/srp';

type OwnProps = {
  vehicles: Vehicle[];
};

export default function SimilarResults({ vehicles }: OwnProps) {
  const { favorites } = useContext(FavoritesContext);

  const favoriteVehicleIds = favorites.map(v => v.vehicleId);

  return (
    <>
      {vehicles.map(v => {
        const vehicle: Vehicle = {
          ...v,
          isFavorite: favoriteVehicleIds.includes(v.vehicleId),
          isSimilarTile: true
        };

        return <ResultTile tileData={vehicle} key={vehicle.vehicleId} />;
      })}
    </>
  );
}
